import { mobileAppHeaderMessages } from '@/components/layout/header/mobile-app-header/mobile-app-header.messages';
import { useIntl } from 'react-intl';

import { RoutineRunChatHeader } from '@/features/workflows/components/RoutineRunChatHeader';
import { useRoutineForProject } from '@/features/workflows/hooks';

import {
  ProjectChatHeader as ProjectChatHeaderView,
  type ProjectChatHeaderProps,
} from '@heidi/agents';
import {
  ProjectHeaderActions,
  ProjectHeaderCommonMenuItems,
} from './ProjectHeaderActions';
import { ProjectTitleCluster } from './ProjectTitleCluster';

/**
 * Binds the Work chat header to the app: the routine run backing the chat (its
 * header is the workflows root's), the mobile header's copy, and the title
 * cluster and action menus bound to the chat-list mutations.
 *
 * Lives here — not on the chat page — because the Chat quarantine keeps new
 * chat → workflows imports out; Work already borders workflows. The page reaches
 * it through the `ProjectTitleCluster` door (see that module's header).
 */
export const ProjectChatHeader = (props: ProjectChatHeaderProps) => {
  const intl = useIntl();
  const { workflow: runRoutine } = useRoutineForProject(props.projectId);

  return (
    <ProjectChatHeaderView
      {...props}
      newChatLabel={intl.formatMessage(mobileAppHeaderMessages.newChat)}
      navigationLabel={intl.formatMessage(mobileAppHeaderMessages.openNavigationMenu)}
      TitleCluster={ProjectTitleCluster}
      HeaderActions={ProjectHeaderActions}
      CommonMenuItems={ProjectHeaderCommonMenuItems}
      renderRoutineRunHeader={
        runRoutine
          ? (chrome) => <RoutineRunChatHeader workflow={runRoutine} {...chrome} />
          : undefined
      }
    />
  );
};
